module.exports = Ember.HTMLBars.template((function() {
  var child0 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child1 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child2 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child3 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child4 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child5 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child6 = (function() {
    var child0 = (function() {
      var child0 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, content = hooks.content;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            content(env, morph0, context, "timezone");
            return fragment;
          }
        };
      }());
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          var el1 = dom.createComment("");
          dom.appendChild(el0, el1);
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          var hooks = env.hooks, get = hooks.get, block = hooks.block;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
          dom.insertBoundary(fragment, null);
          dom.insertBoundary(fragment, 0);
          block(env, morph0, context, "sm-select-option", [], {"option": get(env, context, "timezone")}, child0, null);
          return fragment;
        }
      };
    }());
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createComment("");
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, get = hooks.get, block = hooks.block;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
        dom.insertBoundary(fragment, null);
        dom.insertBoundary(fragment, 0);
        block(env, morph0, context, "each", [get(env, context, "timezones")], {"keyword": "timezone"}, child0, null);
        return fragment;
      }
    };
  }());
  var child7 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.organization.timezone.caption"], {});
        return fragment;
      }
    };
  }());
  var child8 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child9 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child10 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child11 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child12 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child13 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  return {
    isHTMLBars: true,
    revision: "Ember@1.11.1",
    blockParams: 0,
    cachedFragment: null,
    hasRendered: false,
    build: function build(dom) {
      var el0 = dom.createDocumentFragment();
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","plain-form settings-organization-page");
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-header");
      var el3 = dom.createElement("h1");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("h2");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","caption");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createTextNode(" ");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","image-preview");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","input-button-group");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("button");
      dom.setAttribute(el6,"class","sm-button bordered-orange");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","caption");
      var el6 = dom.createElement("p");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("p");
      var el7 = dom.createElement("div");
      dom.setAttribute(el7,"class","danger");
      var el8 = dom.createComment("");
      dom.appendChild(el7, el8);
      dom.appendChild(el6, el7);
      var el7 = dom.createElement("span");
      var el8 = dom.createTextNode(" ");
      dom.appendChild(el7, el8);
      var el8 = dom.createComment("");
      dom.appendChild(el7, el8);
      dom.appendChild(el6, el7);
      var el7 = dom.createElement("span");
      dom.setAttribute(el7,"class","link-support-modal");
      var el8 = dom.createComment("");
      dom.appendChild(el7, el8);
      dom.appendChild(el6, el7);
      var el7 = dom.createElement("span");
      var el8 = dom.createTextNode(" ");
      dom.appendChild(el7, el8);
      var el8 = dom.createComment("");
      dom.appendChild(el7, el8);
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","caption");
      var el6 = dom.createElement("p");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","toggle-group");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("div");
      dom.setAttribute(el6,"class","text");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("div");
      dom.setAttribute(el6,"class","caption");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createTextNode("Twitter");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createTextNode("Facebook");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createTextNode("Instagram");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createTextNode("Telegram");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label emoji");
      var el5 = dom.createTextNode("⚠️");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","text");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","button-block");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      return el0;
    },
    render: function render(context, env, contextualElement) {
      var dom = env.dom;
      var hooks = env.hooks, inline = hooks.inline, content = hooks.content, get = hooks.get, block = hooks.block, element = hooks.element;
      dom.detectNamespace(contextualElement);
      var fragment;
      if (env.useFragmentCache && dom.canClone) {
        if (this.cachedFragment === null) {
          fragment = this.build(dom);
          if (this.hasRendered) {
            this.cachedFragment = fragment;
          } else {
            this.hasRendered = true;
          }
        }
        if (this.cachedFragment) {
          fragment = dom.cloneNode(this.cachedFragment, true);
        }
      } else {
        fragment = this.build(dom);
      }
      var element0 = dom.childAt(fragment, [0]);
      var element1 = dom.childAt(element0, [0]);
      var element2 = dom.childAt(element0, [1]);
      var element3 = dom.childAt(element2, [0]);
      var element4 = dom.childAt(element3, [1]);
      var element5 = dom.childAt(element2, [1]);
      var element6 = dom.childAt(element5, [1]);
      var element7 = dom.childAt(element6, [1]);
      var element8 = dom.childAt(element2, [2]);
      var element9 = dom.childAt(element2, [3]);
      var element10 = dom.childAt(element2, [4]);
      var element11 = dom.childAt(element0, [2]);
      var element12 = dom.childAt(element11, [0]);
      var element13 = dom.childAt(element12, [1, 0]);
      var element14 = dom.childAt(element13, [1]);
      var element15 = dom.childAt(element11, [1]);
      var element16 = dom.childAt(element15, [1]);
      var element17 = dom.childAt(element16, [1]);
      var element18 = dom.childAt(element17, [1]);
      var element19 = dom.childAt(element18, [2]);
      var element20 = dom.childAt(element11, [2]);
      var element21 = dom.childAt(element20, [1]);
      var element22 = dom.childAt(element0, [3, 0]);
      var element23 = dom.childAt(element22, [1]);
      var element24 = dom.childAt(element0, [4, 0]);
      var element25 = dom.childAt(element24, [1, 0]);
      var element26 = dom.childAt(element0, [5]);
      var element27 = dom.childAt(element26, [4]);
      var element28 = dom.childAt(element26, [5]);
      var element29 = dom.childAt(element0, [7, 0]);
      var morph0 = dom.createMorphAt(dom.childAt(element1, [0]),0,0);
      var morph1 = dom.createMorphAt(dom.childAt(element1, [1]),0,0);
      var morph2 = dom.createMorphAt(dom.childAt(element3, [0]),0,0);
      var morph3 = dom.createMorphAt(element4,0,0);
      var morph4 = dom.createMorphAt(dom.childAt(element4, [1]),0,0);
      var morph5 = dom.createMorphAt(dom.childAt(element5, [0]),1,1);
      var morph6 = dom.createMorphAt(element6,0,0);
      var morph7 = dom.createMorphAt(element6,2,2);
      var morph8 = dom.createMorphAt(dom.childAt(element8, [0]),0,0);
      var morph9 = dom.createMorphAt(dom.childAt(element8, [1]),0,0);
      var morph10 = dom.createMorphAt(dom.childAt(element9, [0]),0,0);
      var morph11 = dom.createMorphAt(dom.childAt(element9, [1]),0,0);
      var morph12 = dom.createMorphAt(dom.childAt(element10, [0]),0,0);
      var morph13 = dom.createMorphAt(dom.childAt(element10, [1]),0,0);
      var morph14 = dom.createMorphAt(dom.childAt(element12, [0]),0,0);
      var morph15 = dom.createMorphAt(element13,0,0);
      var morph16 = dom.createMorphAt(element14,0,0);
      var morph17 = dom.createMorphAt(dom.childAt(element15, [0]),0,0);
      var morph18 = dom.createMorphAt(element16,0,0);
      var morph19 = dom.createMorphAt(dom.childAt(element17, [0]),0,0);
      var morph20 = dom.createMorphAt(dom.childAt(element18, [0]),0,0);
      var morph21 = dom.createMorphAt(dom.childAt(element18, [1]),1,1);
      var morph22 = dom.createMorphAt(element19,0,0);
      var morph23 = dom.createMorphAt(dom.childAt(element18, [3]),1,1);
      var morph24 = dom.createMorphAt(dom.childAt(element20, [0]),0,0);
      var morph25 = dom.createMorphAt(element21,0,0);
      var morph26 = dom.createMorphAt(dom.childAt(element21, [1, 0]),0,0);
      var morph27 = dom.createMorphAt(dom.childAt(element22, [0]),0,0);
      var morph28 = dom.createMorphAt(element23,0,0);
      var morph29 = dom.createMorphAt(element23,1,1);
      var morph30 = dom.createMorphAt(dom.childAt(element24, [0]),0,0);
      var morph31 = dom.createMorphAt(element25,0,0);
      var morph32 = dom.createMorphAt(dom.childAt(element25, [1]),0,0);
      var morph33 = dom.createMorphAt(dom.childAt(element25, [2]),0,0);
      var morph34 = dom.createMorphAt(dom.childAt(element26, [0, 1]),0,0);
      var morph35 = dom.createMorphAt(dom.childAt(element26, [1, 1]),0,0);
      var morph36 = dom.createMorphAt(dom.childAt(element26, [2, 1]),0,0);
      var morph37 = dom.createMorphAt(dom.childAt(element26, [3, 1]),0,0);
      var morph38 = dom.createMorphAt(dom.childAt(element27, [0]),0,0);
      var morph39 = dom.createMorphAt(dom.childAt(element27, [1]),0,0);
      var morph40 = dom.createMorphAt(dom.childAt(element28, [0]),0,0);
      var morph41 = dom.createMorphAt(dom.childAt(element28, [1]),0,0);
      var morph42 = dom.createMorphAt(dom.childAt(element0, [6, 0, 1, 0]),0,0);
      var morph43 = dom.createMorphAt(element29,0,0);
      var morph44 = dom.createMorphAt(element29,1,1);
      inline(env, morph0, context, "t", ["settings.organization.title"], {});
      inline(env, morph1, context, "t", ["settings.organization.subtitle"], {});
      inline(env, morph2, context, "t", ["settings.organization.labels.id"], {});
      content(env, morph3, context, "organization.id");
      inline(env, morph4, context, "t", ["settings.organization.caption.id"], {});
      inline(env, morph5, context, "t", ["settings.organization.labels.logo"], {});
      block(env, morph6, context, "sm-file-input", [], {"registerAs": get(env, context, "fileInput"), "accept": "image", "onFileSelected": "uploadPhoto"}, child0, null);
      element(env, element7, context, "bind-attr", [], {"style": get(env, context, "imageStyle")});
      block(env, morph7, context, "sm-button", [], {"classNames": "medium", "textTranslation": "settings.organization.buttons.upload_logo", "type": "bordered-orange", "isLoading": get(env, context, "fileIsUploading"), "action": "openFileDialog"}, child1, null);
      inline(env, morph8, context, "t", ["settings.organization.labels.name"], {});
      block(env, morph9, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "settings.organization.placeholders.name", "value": get(env, context, "organization.name")}, child2, null);
      inline(env, morph10, context, "t", ["settings.organization.labels.phone"], {});
      block(env, morph11, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "settings.organization.placeholders.phone", "value": get(env, context, "organization.phone")}, child3, null);
      inline(env, morph12, context, "t", ["settings.organization.labels.about"], {});
      block(env, morph13, context, "sm-text-area", [], {"classNames": "full-width", "placeholderTranslation": "settings.organization.placeholders.about", "value": get(env, context, "organization.about")}, child4, null);
      inline(env, morph14, context, "t", ["settings.organization.labels.hostname"], {});
      block(env, morph15, context, "sm-text-field", [], {"classNames": "full-width", "placeholderTranslation": "settings.organization.placeholders.hostname", "value": get(env, context, "organization.normalizedHost"), "readonly": "readonly"}, child5, null);
      element(env, element14, context, "action", ["transitionTo", "settings.organization.host"], {"on": "click"});
      inline(env, morph16, context, "t", ["settings.organization.buttons.change_host"], {});
      inline(env, morph17, context, "t", ["settings.organization.labels.advanced_head"], {});
      inline(env, morph18, context, "sm-text-area", [], {"classNames": "full-width", "placeholderTranslation": "settings.organization.placeholders.advanced_head", "value": get(env, context, "organization.head_embedded_content")});
      inline(env, morph19, context, "t", ["settings.organization.labels.advanced_settings.head.caption.description"], {});
      inline(env, morph20, context, "t", ["settings.organization.labels.advanced_settings.head.caption.warning"], {});
      inline(env, morph21, context, "t", ["settings.organization.labels.advanced_settings.head.caption.ask_support_description_before"], {});
      element(env, element19, context, "action", ["askSupport"], {"on": "click"});
      inline(env, morph22, context, "t", ["settings.organization.labels.advanced_settings.head.caption.ask_support"], {});
      inline(env, morph23, context, "t", ["settings.organization.labels.advanced_settings.head.caption.ask_support_description_after"], {});
      inline(env, morph24, context, "t", ["settings.organization.labels.advanced_body"], {});
      inline(env, morph25, context, "sm-text-area", [], {"classNames": "full-width", "placeholderTranslation": "settings.organization.placeholders.advanced_body", "value": get(env, context, "organization.embedded_content")});
      inline(env, morph26, context, "t", ["settings.organization.labels.advanced_settings.body.caption.description"], {});
      inline(env, morph27, context, "t", ["settings.organization.labels.timezone"], {});
      block(env, morph28, context, "sm-select", [], {"propBehaviour": "one-way", "selectedOption": get(env, context, "timezone"), "onOptionSelected": "changeTimezone"}, child6, null);
      block(env, morph29, context, "if", [get(env, context, "hasDefaultTimezone")], {}, child7, null);
      inline(env, morph30, context, "t", ["settings.organization.labels.is_published"], {});
      inline(env, morph31, context, "sm-toggle", [], {"checked": get(env, context, "organization.is_published")});
      inline(env, morph32, context, "t", ["settings.organization.is_published.text"], {});
      inline(env, morph33, context, "t", ["settings.organization.is_published.description"], {});
      block(env, morph34, context, "sm-prefilled-input", [], {"classNames": "full-width", "placeholder": "https://twitter.com/", "prefilled": "https://twitter.com/", "value": get(env, context, "twitterUrl")}, child8, null);
      block(env, morph35, context, "sm-prefilled-input", [], {"classNames": "full-width", "placeholder": "https://facebook.com/", "prefilled": "https://facebook.com/", "value": get(env, context, "facebookUrl")}, child9, null);
      block(env, morph36, context, "sm-prefilled-input", [], {"classNames": "full-width", "placeholder": "https://instagram.com/", "prefilled": "https://instagram.com/", "value": get(env, context, "instagramUrl")}, child10, null);
      block(env, morph37, context, "sm-prefilled-input", [], {"classNames": "full-width", "placeholder": "https://t.me/", "prefilled": "https://t.me/", "value": get(env, context, "telegramUrl")}, child11, null);
      inline(env, morph38, context, "t", ["settings.organization.labels.vk"], {});
      block(env, morph39, context, "sm-prefilled-input", [], {"classNames": "full-width", "placeholder": "https://vkontakte.ru/", "prefilled": "https://vkontakte.ru/", "value": get(env, context, "vkUrl")}, child12, null);
      inline(env, morph40, context, "t", ["settings.organization.labels.whatsapp"], {});
      block(env, morph41, context, "sm-prefilled-input", [], {"classNames": "full-width", "placeholder": "https://wa.me/", "prefilled": "https://wa.me/", "value": get(env, context, "whatsappUrl")}, child13, null);
      inline(env, morph42, context, "t", ["settings.organization.lang_settings_helper"], {});
      inline(env, morph43, context, "sm-button", [], {"textTranslation": "sm_button.save", "isLoading": get(env, context, "isSaving"), "action": "saveOrganization"});
      inline(env, morph44, context, "sm-button", [], {"type": "gray", "textTranslation": "sm_button.cancel", "action": "discartChanges"});
      return fragment;
    }
  };
}()));